function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "27",
  height: "27",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: "27",
  height: "27",
  rx: "3.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 20.528l.003.003A5.136 5.136 0 009.12 22a5.136 5.136 0 003.62-1.472l10.102-9.914A3.814 3.814 0 0024 7.874c0-1.035-.41-2.009-1.157-2.74A3.975 3.975 0 0020.051 4a3.975 3.975 0 00-2.793 1.133L9.284 12.96a2.694 2.694 0 000 3.856 2.819 2.819 0 003.928 0l6.402-6.282a.568.568 0 000-.813.594.594 0 00-.83 0l-6.4 6.282a1.63 1.63 0 01-2.272 0 1.557 1.557 0 010-2.23l7.975-7.825a2.818 2.818 0 013.928 0c.524.514.813 1.199.813 1.927s-.289 1.412-.813 1.927l-10.103 9.914A3.961 3.961 0 019.12 20.85a3.96 3.96 0 01-2.792-1.135l-.002-.003a3.813 3.813 0 01-1.154-2.737c0-1.035.41-2.008 1.156-2.74l8.529-8.37a.567.567 0 000-.813.594.594 0 00-.829 0L5.5 13.422A4.945 4.945 0 004 16.975c0 1.342.533 2.604 1.5 3.553z",
  fill: "#54585D"
}))));